import Vue from "vue";
import App from "./App.vue";
//import slug from "slug";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;

Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(require('vue-moment'));

//slug.defaults.mode = 'rfc3986';

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");


/**
 * Vue filter to convert the given value to percent.
 * http://jsfiddle.net/bryan_k/qauf3qyh/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.filter('percentage', function(value, decimals) {
    if(!value) {
      value = 0;
    }
  
    if(!decimals) {
      decimals = 0;
    }
  
    value = value * 100;
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    value = value + '%';
    return value;
});